import React from 'react';
import {
  Popover,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox
} from '@mui/material';

/**
 * Component for managing column visibility in the invoice items table
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the popover is open
 * @param {HTMLElement} props.anchorEl - The element to anchor the popover to
 * @param {Function} props.onClose - Function to call when the popover is closed
 * @param {Object} props.visibleColumns - Object containing column visibility state
 * @param {Function} props.onColumnToggle - Function to call when a column visibility is toggled
 */
const ColumnSettingsPopover = ({ 
  open, 
  anchorEl, 
  onClose, 
  visibleColumns, 
  onColumnToggle 
}) => {
  // Column definitions with labels
  const columns = [
    { name: 'description', label: 'Description' },
    { name: 'priceWithVat', label: 'Price + VAT' },
    { name: 'discountPerc', label: 'Discount %' },
    { name: 'discountAmt', label: 'Discount Amount' },
    { name: 'netValue', label: 'Net Value' },
    { name: 'vatAmount', label: 'VAT Amount' },
    { name: 'grandTotal', label: 'Grand Total' }
  ];

  return (
    <Popover
      id="column-visibility-menu"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box sx={{ p: 2, width: 250 }}>
        <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
          Column Visibility
        </Typography>
        <List dense>
          {columns.map((column) => (
            <ListItem 
              key={column.name}
              dense
              sx={{ 
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
              onClick={() => onColumnToggle && onColumnToggle(column.name)}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Checkbox
                  edge="start"
                  checked={visibleColumns?.[column.name] || false}
                  tabIndex={-1}
                  disableRipple
                  size="small"
                  onChange={() => onColumnToggle && onColumnToggle(column.name)}
                />
              </ListItemIcon>
              <ListItemText 
                primary={column.label}
                primaryTypographyProps={{ fontSize: '0.875rem' }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Popover>
  );
};

export default ColumnSettingsPopover;
